module.exports = __webpack_public_path__ + "static/img/dzxg.78ff970.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dzxg.jpg
// module id = bGn+
// module chunks = 4